<!--
 * @Description:
 * @Author: kangkang
 * @Date: 2022-08-08 17:23:56
 * @LastEditTime: 2023-04-09 22:37:38
 * @LastEditors: kangkang
 * @Reference:
-->
<template>
    <div class="videos">
        <div class="videos-content">
            <div class="content">
                <div class="avtar-bac">
                    <img src="http://img.mp.itc.cn/upload/20161210/5a617135641d40229aa896fe345c2b6a_th.jpeg" alt="" />
                </div>

                <div class="text text-title">沉痛悼念</div>
                <div class="text text-content">父亲大人 某某某某</div>
            </div>
            <video
                :src="url"
                loop
                webkit-playsinline="true"
                playsinline="true"
                x-webkit-airplay="allow"
                x5-playsinline
                style="width: 100%;height: 100%"
                :autoplay="true"
                muted="true"
            >
            </video>
        </div>

    </div>

</template>
<script>
export default {
    name: "videoss",
    data() {
        return {
            url: "https://huzhou-back.shyouhan.com//app/admin/upload/files/20230401/6427fa3065a4.mp4",
            show: false,
        };
    },
    components: {
    },
    computed: {},
    methods: {
        cloesePop() {
            this.show = false;
        }
    },

    mounted() {

    },
    created() {

    },
    watch: {
    },
};
</script>
<style rel="stylesheet/scss" lang="scss">
// .van-pull-refresh {
//     height: 100vh;
// }
.van-loading {
    margin: 0 auto;
    width: px2rem(200);
}
.van-popup {
    background: inherit;
}
.videos {
    width: 100%;
    min-height: 100%;
    background: #ffffff;
    box-sizing: border-box;
    &-content {
        position: relative;
        padding: 0;
        .content {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .avtar-bac {
                width: px2rem(380);
                height: px2rem(514);
                background: url(../../assets/video-avtar.png) no-repeat;
                background-size: 100% 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 auto;
                img {
                    display: block;
                    width: px2rem(310);
                    height: px2rem(430);
                }
            }
            .text {
                color: #000000;
                text-align: center;
            }
            .text-title {
                font-size: px2rem(124);
                margin-top: px2rem(16);
            }
            .text-content {
                font-size: px2rem(66);
            }
        }
        video {
            width: 100%;
            height: 100%;
        }
    }


}
</style>
